
import {
  Mixins,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import {
  Card,
  Col,
  Button,
  Row,
  Tooltip,
  Dialog,
  Tabs,
  TabPane,
  Pagination,
} from 'element-ui';

import BsMixin from '@/views/Home/mixins/bsMixin';
import BScroll from 'better-scroll';
import tableMixin from '@/views/Home/layout/userManage/tableMixin';
import api from '@/api/user';
import bModal from '@/views/Home/layout/verify/works/components/bModal.vue';
import noData from '@/components/noData/index.vue';

  @Component({
    components: {
      Card,
      Col,
      Button,
      Row,
      Tooltip,
      Tabs,
      TabPane,
      Dialog,
      bModal,
      Pagination,
      noData,
    },
  })

export default class cardList extends Mixins(BsMixin, tableMixin) {
  @Prop({
    required: true,
    default: false,
  })otherProject!: any;

  private bs?: BScroll;

  public $refs!:{
      list: Element,
      wrapper: Element
  }

  mounted() {
    this.initBS(this.$refs.list, {
      click: false,
    });
    this.bs = this.initBS(this.$refs.list);
    this.bs.on('scrollEnd', (cood: any) => {
      if (cood.y === 0) return;
      const contentHeight: number = this.$refs.list.clientHeight;
      const wrapperHeight: number = Math.abs(this.$refs.wrapper.getBoundingClientRect().height);
      if (contentHeight + Math.abs(cood.y) > wrapperHeight - 10) {
        this.$emit('getScrollData');
      }
    });
  }

  private isShowManageComment:Boolean = false; // 评论管理模态框

  private projectId: String = ''; // 用于获取作品评论

  // 管理评论
  manageComment(item) {
    this.projectId = item.pid;
    this.getCommentList(item.pid);
  }

  // 删除评论
  deleteComment(commentPid) {
    api.deleteComment(commentPid).then((res: any) => {
      this.getCommentList(this.projectId);
    });
  }

  private comments: any = [] // 评论数据

  // 获取评论数据
  getCommentList(pid) {
    const params = { pageSize: this.page.pageSize, pageNo: this.page.pageNo };
    api.getProjectComment(params, pid).then((res: any) => {
      this.comments = res.content;
      if (res) {
        this.isShowManageComment = true;
      }
      this.total = res.totalElements;
    });
  }

  sizeChange(size) {
    this.page.pageSize = size;
    this.getCommentList(this.projectId);
  }

  pageChange(page) {
    this.page.pageNo = page;
    this.getCommentList(this.projectId);
  }

  private dialogVisible: boolean = false; // 作品审核显示隐藏

  private worksItem: any = []; // 审核作品数据

  private showFlag: boolean = false;

  private verifyTitle: string = '作品审核';

  // bmodal 点击确定重新获取页面列表
  eventGetData() {
    this.$emit('bModalOk');
  }

  // 审核作品
  projectAudit(item) {
    this.dialogVisible = true;
    this.worksItem = item;
    this.showFlag = false;
  }

  /* eslint-disable class-methods-use-this */
  getPath(item: any) {
    if (item.imagePath) return item.imagePath;
    return require('@/assets/imgs/login_bg.png');
  }

  private clickProjectItem: any = {}

  /* eslint-disable class-methods-use-this */
  viewDetail(item: any) {
    this.clickProjectItem = item;
    if (item.version === 2) {
      window.open(`${process.env.VUE_APP_SCRATCH_2X}${item.pid}`);
    }
    if (item.version === 3) {
      window.open(`${process.env.VUE_APP_SCRATCH_3X}${item.pid}`);
    }
  }
}
